module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\">Code Generator Error</h3>\n</div>\n<div class=\"modal-body\">\n  <p>{{data.message}}</p>\n  <p>Details:</p>\n  <json-formatter json=\"data\" class=\"json-formatter-dark\"></json-formatter>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-warning\" ng-click=\"cancel()\">OK</button>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./templates/code-gen-error-modal.html
 ** module id = 392
 ** module chunks = 0
 **/